export default __webpack_public_path__ + "static/media/Strong.6d90b00c.svg";